import type {
  mutationAddTagsForCaseItems,
  mutationAddTagsForCaseItemsVariables,
} from 'Constants/graphql/mutations/__generated__/mutationAddTagsForCaseItems'
import type {
  mutationRemoveTagsForCaseItems,
  mutationRemoveTagsForCaseItemsVariables,
} from 'Constants/graphql/mutations/__generated__/mutationRemoveTagsForCaseItems'
import { MUTATION_ADD_TAGS_FOR_CASE_ITEMS } from 'Constants/graphql/mutations/MutationAddTagsForCaseItems'
import { MUTATION_REMOVE_TAGS_FOR_CASE_ITEMS } from 'Constants/graphql/mutations/MutationRemoveTagsForCaseItems'

import { TAG_COLOR } from 'Portal/__generated__/globalTypes'

import type { TagColor } from './tagging.types'
import { normalizeTagColor } from './tagging.utils'
import type { TaggingEntityAdapter } from './taggingEntityAdapter.types'

export const orderTaggingAdapter = {
  add: {
    document: MUTATION_ADD_TAGS_FOR_CASE_ITEMS,
    getAffectedEntityIds: (data: mutationAddTagsForCaseItems) =>
      Array.from(
        new Set(
          (data.addTagsForCaseItems.items ?? []).map(item =>
            String(item.taggable_id),
          ),
        ),
      ),
    operationName: 'addTagsForCaseItems',
    toVariables: ({ color, entityIds, name, orgId }) => ({
      input: {
        caseItemIDs: entityIds,
        orgID: orgId,
        tags: [{ color: TAG_COLOR[normalizeTagColor(color)], name }],
      },
    }),
  },
  getTagsFromHit: hit =>
    (hit['case_item.tags'] ?? []).map(tag => ({
      // Typesense stores this as a string rather than the GraphQL TAG_COLOR enum.
      color: tag.color as TagColor,
      id: String(tag.id),
      name: tag.name,
    })),
  messages: {
    addError: 'OrderTags_add_error',
    added: 'OrderTags_added',
    applyingToCount: 'OrderTags_applying_to_count',
    removeError: 'OrderTags_remove_error',
    removed: 'OrderTags_removed',
  },
  remove: {
    document: MUTATION_REMOVE_TAGS_FOR_CASE_ITEMS,
    operationName: 'removeTagsForCaseItems',
    toVariables: ({ entityIds, orgId, tagIds }) => ({
      input: {
        caseItemIDs: entityIds,
        orgID: orgId,
        tagIDs: tagIds,
      },
    }),
  },
  scopeSelector: '.OrderTagsRow',
} satisfies TaggingEntityAdapter<
  mutationAddTagsForCaseItems,
  mutationAddTagsForCaseItemsVariables,
  mutationRemoveTagsForCaseItems,
  mutationRemoveTagsForCaseItemsVariables
>
